import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const SYMBOLS = ['🪙', '💎', '⭐', '7️⃣', '🍀', '🎁'];

const SlotMachine = ({ prize, onComplete }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [reels, setReels] = useState(['⭐', '⭐', '⭐']);
  
  const spin = () => {
    if (isSpinning || !prize) return;
    setIsSpinning(true);

    // Determine target symbols based on prize
    // For simplicity, if it's a high prize, make them match. Otherwise, mixed.
    let targetSymbols = [];
    if (prize.points >= 100) {
      targetSymbols = ['7️⃣', '7️⃣', '7️⃣']; // Jackpot
    } else if (prize.points >= 50) {
      targetSymbols = ['💎', '💎', '💎'];
    } else {
      // Just pick random matching or non-matching
      const icon = prize.icon || '🪙';
      targetSymbols = [icon, icon, icon];
    }

    // Animation sequence
    let currentSpins = 0;
    const maxSpins = 20; // How many times to change symbols before stopping
    
    const interval = setInterval(() => {
      setReels([
        SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)],
        SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)],
        SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)]
      ]);
      
      currentSpins++;
      
      if (currentSpins >= maxSpins) {
        clearInterval(interval);
        // Stop reels one by one
        setTimeout(() => setReels([targetSymbols[0], reels[1], reels[2]]), 0);
        setTimeout(() => setReels([targetSymbols[0], targetSymbols[1], reels[2]]), 500);
        setTimeout(() => {
          setReels(targetSymbols);
          setIsSpinning(false);
          setTimeout(onComplete, 1000);
        }, 1000);
      }
    }, 100);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="bg-gradient-to-b from-gray-300 to-gray-400 p-4 rounded-2xl shadow-2xl border-4 border-gray-500 mb-8 relative">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-600 text-white text-xs px-4 py-1 rounded-full font-bold shadow-md border-2 border-red-800">
          LUCKY SLOTS
        </div>
        
        <div className="flex gap-2 bg-gray-900 p-4 rounded-xl shadow-inner mt-2">
          {reels.map((symbol, i) => (
            <div 
              key={i} 
              className="w-16 h-20 bg-white rounded-lg flex items-center justify-center text-4xl shadow-inner overflow-hidden relative"
            >
              <motion.div
                animate={isSpinning ? { y: [0, 50, -50, 0] } : { y: 0 }}
                transition={isSpinning ? { repeat: Infinity, duration: 0.2, ease: "linear" } : {}}
              >
                {symbol}
              </motion.div>
              {/* Overlay shadow for depth */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20 rounded-lg pointer-events-none" />
            </div>
          ))}
        </div>
      </div>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={spin}
        disabled={isSpinning || !prize}
        className={`px-10 py-4 rounded-full text-white font-bold text-2xl shadow-[0_6px_0_rgb(153,27,27)] active:shadow-[0_0px_0_rgb(153,27,27)] active:translate-y-[6px] transition-all ${isSpinning ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-500'}`}
      >
        {isSpinning ? '...' : 'PULL'}
      </motion.button>
    </div>
  );
};

export default SlotMachine;